import React from 'react';
import styles from './style.module.scss';

const PageContainer = ({children}) => (
    <div className={styles.pageContainer}>
        {children}
    </div>
);
 
export default PageContainer;